import { render, staticRenderFns } from "./quitar.vue?vue&type=template&id=cd0bb93c"
import script from "./quitar.vue?vue&type=script&lang=js"
export * from "./quitar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports